<template>
  <div>
    <v-btn color="green" dark @click="openUrl('https://www.sing.co.jp/corp/contact/')">
      問い合わせフォーム
    </v-btn>
    <p class="mt-2" :style="{ fontSize: fontSize, color: 'red', fontWeight: 'bold' }">
      システム、問題内容、エラーなどに関するお問い合わせは、<br>
      「よくある質問」を事前にご確認いただいた上で、解決しない場合は、<br>
      上記のボタンを押して、弊社問い合わせ窓口からご連絡ください。
    </p>
  </div>
</template>

<script>

export default {
  props: {
    fontSize: {
      type: String,
      default: '16px',
    },
  },

  methods: {
    openUrl(url) {
      window.open(url, '_blank')
    },
  },
}
</script>
